/**
 * ч.1398: банер у шапці для кожного учасника акаунта — база «лише перегляд» / «недоступна» /
 * оплачений період закінчується, а на балансі не вистачає. Власнику — посилання на «Баланс і тарифи».
 */
import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { billing, fmtDate, fmtUah, type BillingNotice } from '@/api/billing';
import { LegalDocLink } from '@/shared/components/LegalConsent';

function text(n: BillingNotice): string {
  if (n.status === 'BLOCKED') {
    return `База «${n.name}» недоступна: не сплачено. Без оплати її буде видалено ${fmtDate(n.delete_after)}.`;
  }
  if (n.status === 'GRACE') {
    return `База «${n.name}» — лише перегляд до ${fmtDate(n.grace_until)}: оплачений період закінчився, на балансі не вистачає (потрібно ${fmtUah(n.price)}, є ${fmtUah(n.balance)}).`;
  }
  return `База «${n.name}»: оплачений період закінчується ${fmtDate(n.paid_until)} (${n.days_left} дн.), на балансі не вистачає (потрібно ${fmtUah(n.price)}, є ${fmtUah(n.balance)}).`;
}

/** ч.1427: нова редакція оферти. Оферта обіцяє повідомити у Сервісі за 30 днів: банер кожному учаснику. */
function TermsNotice() {
  const q = useQuery({ queryKey: ['billing-legal-notice'], queryFn: billing.legalNotice, staleTime: 60 * 60_000, retry: false });
  const [hidden, setHidden] = useState(false);
  const key = q.data ? `terms-notice:${q.data.until}` : '';
  let seen = false;
  try { seen = !!key && localStorage.getItem(key) === '1'; } catch { /* сховище браузера може бути недоступне */ }
  if (!q.data || hidden || seen) return null;
  return (
    <div role="status" data-testid="terms-notice" className="mc__panel mc__panel--info"
      style={{ margin: '0.75rem 1rem 0', fontSize: '0.85rem', display: 'flex', gap: '0.6rem', alignItems: 'center', flexWrap: 'wrap' }}>
      <span style={{ flex: '1 1 320px' }}>{q.data.text} <LegalDocLink doc="terms">читати оферту</LegalDocLink></span>
      <button type="button" onClick={() => {
        try { localStorage.setItem(key, '1'); } catch { /* показати знову — не біда */ }
        setHidden(true);
      }}>зрозуміло</button>
    </div>
  );
}

export default function BillingNotices() {
  const q = useQuery({ queryKey: ['billing-notices'], queryFn: billing.notices, staleTime: 5 * 60_000, retry: false });
  const items = q.data ?? [];
  if (!items.length) return <TermsNotice />;
  const danger = items.some((n) => n.status === 'BLOCKED' || n.status === 'GRACE');
  return (
    <>
    <TermsNotice />
    <div role="status" data-testid="billing-notices"
      className={`mc__panel ${danger ? 'mc__panel--warn' : 'mc__panel--info'}`}
      style={{ margin: '0.75rem 1rem 0', fontSize: '0.85rem' }}>
      {items.map((n) => <div key={n.organization_id}>{text(n)}</div>)}
      <div style={{ marginTop: '0.3rem' }}>
        {items[0]!.is_owner
          ? <Link to="/account/subscription">Поповнити баланс і продовжити — «Баланс і тарифи»</Link>
          : 'Зверніться до власника акаунта — оплата у розділі «Обліковий запис → Баланс і тарифи».'}
      </div>
    </div>
    </>
  );
}
